export default __webpack_public_path__ + "static/left-banner-82bf0a381c029ade53dfd73bbfa5ebfa.png";